import moment from 'moment';

export const getDateLabel = (date) => {
  const today = moment();
  const yesterday = moment().subtract(1, 'days');
  
  if (date.isSame(today, 'day')) {
    return 'TODAY';
  } else if (date.isSame(yesterday, 'day')) {
    return 'YESTERDAY';
  } else if (date.isSame(today, 'year')) {
    return date.format('MMMM D'); // e.g., "December 23"
  } else {
    return date.format('MMMM D, YYYY'); // e.g., "December 23, 2024"
  }
};